// Quick chat sepia palette — see implementation spec §7.
// Co-located with the quick-chat surface so it's clearly out-of-band from
// the standard chat brand tokens.

export const QC = {
  bgPage: "#100c0a",
  bgPanel: "#161210",
  bgSidebar: "#0d0a08",
  border: "#2a221c",
  borderSoft: "#1c1612",
  borderDash: "#5a4a3a",
  borderDashSoft: "#4a3f34",
  fg: "#ebe0cf",
  fgMid: "#d4c8b8",
  fgSub: "#b6a994",
  fgMute: "#8a7e6e",
  fgFaint: "#6a5e4e",
  accentBolt: "#d4a86a",
  brandYellow: "#FFC34D",
  stripe: "linear-gradient(90deg,#d4a86a,#a07a48,#d4a86a,#7a5a32)",
  hatchOverlay:
    "repeating-linear-gradient(45deg, rgba(255,255,255,0.05) 0 1px, transparent 1px 18px)",
};

export default QC;
